import React from 'react';

import { TagCloseButton, TagLabel } from '@vimeo/bokeh';
import { Input } from '@vimeo/iris/components';

import { EMAIL_REGEX, T } from './constants';
import { EmailFieldWrapper, EmailInputWrapper, EmailTag, ErrorMsg } from './Styles';

interface Props {
  emails: string[];
  removeEmail: (index: number) => void;
  updateEmailArray: (s: string) => void;
  onAddEmail?: VoidFunction;
}

interface State {
  isValidEmail: boolean;
  inputStr: string;
}

export class EmailValidation extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      isValidEmail: true,
      inputStr: '',
    };
  }

  public render() {
    const { emails, removeEmail } = this.props;
    const { isValidEmail, inputStr } = this.state;

    return (
      <EmailFieldWrapper>
        <EmailInputWrapper>
          <Input
            name="email"
            id="userEmail"
            label={T.Email}
            placeholder={T.EmailText}
            status={isValidEmail ? 'neutral' : 'negative'}
            messages={!isValidEmail ? { error: <ErrorMsg>{T.InvalidEmail}</ErrorMsg> } : undefined}
            value={inputStr}
            onChange={this.handleChange}
            onKeyDown={this.handleKeyDown}
            onBlur={this.offFocus}
          />
        </EmailInputWrapper>
        {emails.map((email, index) => {
          return (
            <EmailTag size="sm" key={`EMAIL_${index}`}>
              <TagLabel>{email}</TagLabel>
              <TagCloseButton onClick={() => removeEmail(index)} />
            </EmailTag>
          );
        })}
      </EmailFieldWrapper>
    );
  }

  private updateEmailFieldValue = (s: string) => {
    this.setState({
      inputStr: s,
    });
  };

  private clearEmailField = () => {
    this.setState({
      inputStr: '',
    });
  };

  private setEmailValidity = (val: boolean) => {
    this.setState({
      isValidEmail: val,
    });
  };

  private handleEmailInput = (s: string) => {
    const arr = s.split(',');
    for (let email of arr) {
      email = email.trim();
      if (email && EMAIL_REGEX.test(String(email).toLowerCase())) {
        this.setEmailValidity(true);
        this.props.updateEmailArray(email);
        this.clearEmailField();
        if (this.props.onAddEmail) {
          this.props.onAddEmail();
        }
      } else {
        this.setEmailValidity(false);
      }
    }
  };

  private offFocus = (event: React.ChangeEvent<HTMLInputElement>) => {
    const s = event.target.value;
    if (s && s.length !== 0) {
      this.handleEmailInput(s);
    }
  };

  private handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.persist();
    const s = event.target.value;

    if (!(s.length && (s[0] === ',' || s[0] === ' '))) {
      this.updateEmailFieldValue(s);
    }
  };

  private handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    const s = event.target ? (event.target as HTMLTextAreaElement).value : '';
    if (
      s.length &&
      (event.key === ',' || event.key === 'Tab' || event.key === 'Enter' || event.key === ' ')
    ) {
      event.preventDefault(); // to preserve the cursor after `Tab` key press.
      this.handleEmailInput(s);
    } else {
      this.setEmailValidity(true);
    }
  };
}
